import { AUTHENTICATION_TYPES } from '@seek/apac-candidate-header-footer/types';
import { metrics } from '@seek/metrics-js';
import { useEffect, useState } from 'react';
import { useEffectOnce } from 'react-use';

import { JOB_TYPE } from 'src/const/app';
import { analyticsClient } from 'src/modules/analytics/analytics';
import type { AppliedJob, SavedJob } from 'src/types/graphql';

const useTracking = (
  jobs: Array<SavedJob & AppliedJob>,
  type: typeof JOB_TYPE.applied | typeof JOB_TYPE.saved,
  authenticationStatus: AUTHENTICATION_TYPES,
  sortMode: '' | 'applied_date_desc' | 'company_name_asc' | 'job_title_asc',
  loading: boolean,
) => {
  useEffectOnce(() => {
    if (type === JOB_TYPE.saved) {
      metrics.sendInitialLoadTime('savedjobs');
    }
    if (type === JOB_TYPE.applied) {
      metrics.sendInitialLoadTime('appliedjobs');
    }
  });

  const [initialTrackingFired, setInitialTrackingFired] = useState(false);

  const applicationStatus = jobs?.some((job) =>
    job.events?.some((event) => event.status === 'Viewed'),
  )
    ? 'viewed'
    : 'not viewed';

  useEffect(() => {
    if (
      authenticationStatus !== AUTHENTICATION_TYPES.AUTHENTICATED ||
      loading ||
      initialTrackingFired
    )
      return;
    if (type === JOB_TYPE.saved) {
      analyticsClient.setState({
        currentPage: 'my activity',
        currentPageSection: 'saved jobs',
      });
      analyticsClient.trackView({
        eventName: 'my_activity_displayed',
        expiredJobsFilter: '',
      });
    }
    if (type === JOB_TYPE.applied) {
      analyticsClient.setState({
        currentPage: 'my activity',
        currentPageSection: 'applied jobs',
      });
      analyticsClient.trackView({
        eventName: 'my_activity_displayed',
        sortMode,
        applicationStatus,
        appliedJobsCount: jobs.length,
      });
    }
    setInitialTrackingFired(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationStatus, authenticationStatus, type, loading]);
};

export { useTracking };
